import { PPTCreateLoading } from "@/components/fetchLoading/views/pptCreateLoading";
import styles from "./index.module.css";
import { Modal, Progress } from "antd";
import "antd/es/modal/style/css";
import "antd/es/progress/style/css";

interface CreatePPTProgressProps {
  // 进度
  percent: number;
  onClose?: () => void;
}

export const CreatePPTProgress = (props: CreatePPTProgressProps) => {
  const { percent = 0, onClose } = props;
  return (
    <Modal
      open={true}
      width={360}
      closable={true}
      className={styles.createPPTProgressModal}
      bodyStyle={{
        padding: 0,
      }}
      centered
      footer={null}
      onCancel={onClose}
    >
      <div className={styles.createPPTProgressContent}>
        <PPTCreateLoading />
        <Progress
          percent={percent}
          strokeWidth={3}
          strokeColor="#66A8FF"
          showInfo={false}
        />
        <div className={styles.createPPTProgressContentText}>
          生成PPT中（已完成{percent}%）
        </div>
        <div className={styles.createPPTProgressContentDes}>
          DeepSeek R1 正在拼命思考...
        </div>
      </div>
    </Modal>
  );
};
